export default "__VITE_ASSET__C9a_ykBY__"